import { IGetOneResponse } from '../util/Types/Generic';
import { ApiService } from './ApiService';

export class ProcessService extends ApiService {
  static pathName = '/process';

  static response = (body: {
    nodeId: string;
    sessionId: string;
    flowId: string;
  }): Promise<IGetOneResponse<any>> => {
    return ApiService.post(`${this.pathName}/single-node`, body);
  };
}
